import Select from "react-dropdown-select";

const CustomDropdown = ({
   label,
   optionData,
   onChange,
   name,
   values,
   disabled,
   errors,
   message,
   require,
   multiple = false,
   labelField,
   valueField,
   value,
}) => {
   const getSelectedValue = () => {
      let selectedValue = [{ label: "", value: "" }];

      if (values) {
         return values;
      }

      if (value) {
         selectedValue = optionData?.filter?.((item) => item?.value === value);
      }

      return selectedValue;
   };

   return (
      <div className="form-group">
         {label && (
            <label className="text-capitalize">
               {label}
               {require && <span className="text-danger">*</span>}
            </label>
         )}
         <Select
            options={optionData}
            labelField={labelField || "label"}
            valueField={valueField || "value"}
            name={name}
            values={getSelectedValue()}
            onChange={(data) => {
               onChange(data, data?.[0]?.value);
            }}
            searchable
            multi={multiple}
            disabled={disabled}
            searchBy={labelField || "label"}
            style={{
               backgroundColor: disabled ? "#e9ecef" : "#fff",
               // zIndex: 999999999,
               // width: "100%",
               // width:"minimum-content"
               minWidth: "100px",
            }}
         />
         {errors && (
            <div className="text-danger" style={{ fontSize: ".8rem" }}>
               {message}
            </div>
         )}
      </div>
   );
};

export default CustomDropdown;
